export default [
  {
    path: '/admin/defines/purchase-offer-status',
    name: 'PurchaseOfferStatus',
    component: () => import('@/views/Admin/Defines/PurchaseOfferStatus/Index.vue'),
    meta: {
      pageTitle: 'Satınalma Teklif Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/purchase-offer-status/add',
    name: 'PurchaseOfferStatusAdd',
    component: () => import('@/views/Admin/Defines/PurchaseOfferStatus/Add.vue'),
    meta: {
      pageTitle: 'Satınalma Teklif Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/purchase-offer-status',
          active: false,
        },
        {
          text: 'Oluştur',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
  {
    path: '/admin/defines/purchase-offer-status/edit/:id',
    name: 'PurchaseOfferStatusEdit',
    component: () => import('@/views/Admin/Defines/PurchaseOfferStatus/Edit.vue'),
    meta: {
      pageTitle: 'Satınalma Teklif Durumları',
      breadcrumb: [
        {
          text: 'Liste',
          to: '/admin/defines/purchase-offer-status',
          active: false,
        },
        {
          text: 'Güncelle',
          active: true,
        },
      ],
      resource: 'ADMIN_DEFINES_ALL',
      action: 'read',
    },
  },
]
